import { PortableTextComponents } from 'next-sanity';
import {
  TypographyH1,
  TypographyH2,
  TypographyH3,
  TypographyH4,
  TypographyH5,
  TypographyH6,
  TypographyP,
} from '@/components/base/Typography';

export const portableTextComponents: PortableTextComponents = {
  block: {
    h1: ({ children }) => <TypographyH1 className="mt-8 mb-6">{children}</TypographyH1>,
    h2: ({ children }) => <TypographyH2 className="mt-6 mb-4">{children}</TypographyH2>,
    h3: ({ children }) => <TypographyH3 className="mt-5 mb-3">{children}</TypographyH3>,
    h4: ({ children }) => <TypographyH4 className="mt-4 mb-3">{children}</TypographyH4>,
    h5: ({ children }) => <TypographyH5 className="mt-4 mb-2">{children}</TypographyH5>,
    h6: ({ children }) => <TypographyH6 className="mt-3 mb-2">{children}</TypographyH6>,
    normal: ({ children }) => (
      <TypographyP className="mb-4 leading-relaxed">{children}</TypographyP>
    ),

    blockquote: ({ children }) => (
      <blockquote className="border-primary/30 my-6 border-l-4 pl-6 text-lg italic">
        {children}
      </blockquote>
    ),
  },

  list: {
    bullet: ({ children }) => <ul className="mb-4 ml-6 list-disc space-y-2">{children}</ul>,
    number: ({ children }) => <ol className="mb-4 ml-6 list-decimal space-y-2">{children}</ol>,
  },

  listItem: {
    bullet: ({ children }) => <li className="leading-relaxed">{children}</li>,
    number: ({ children }) => <li className="leading-relaxed">{children}</li>,
  },

  marks: {
    strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
    em: ({ children }) => <em className="italic">{children}</em>,
    underline: ({ children }) => <u className="underline">{children}</u>,
    'strike-through': ({ children }) => <s className="line-through">{children}</s>,
    code: ({ children }) => (
      <code className="bg-muted text-muted-foreground rounded px-1.5 py-0.5 font-mono text-sm">
        {children}
      </code>
    ),
    link: ({ children, value }) => (
      <a
        href={value?.href}
        className="text-primary hover:text-primary/80 decoration-primary/30 hover:decoration-primary/60 underline transition-colors"
        target={value?.href?.startsWith('http') ? '_blank' : undefined}
        rel={value?.href?.startsWith('http') ? 'noopener noreferrer' : undefined}
      >
        {children}
      </a>
    ),
  },

  types: {
    image: ({ value }) => {
      let imageUrl = value?.asset?.url;

      return (
        <figure className="my-8 flex items-center justify-center">
          <img
            src={imageUrl}
            alt={value?.alt || value?.caption}
            className="w-1/2 rounded-lg object-cover shadow-md"
            onError={(e) => console.error('Image failed to load:', imageUrl, e)}
          />
          {value?.caption && (
            <figcaption className="text-muted-foreground mt-2 text-center text-sm">
              {value.caption}
            </figcaption>
          )}
        </figure>
      );
    },
  },
};
